import {
    salesOrderLines_salesOrderLines as SalesOrderLines,
    salesOrderLines_salesOrderLines_items as SalesOrderLineItemType,
    salesOrderLines_salesOrderLines_parts as PartType,
} from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrderLines'
import { PRODUCT_COMPLETED_STATUS } from '@Orders/constants'

import {
    PROCESS_DISPLAY_IM,
    PROCESS_DISPLAY_IM_SAMPLE,
} from '~/lib/partsConstants'
import { OrderedItemsRecordType } from '../../OrderedItems/components/types'

export const getSalesItems = (orderItems: SalesOrderLines) => {
    const parts = orderItems?.parts
    const items = orderItems?.items

    const salesItems = parts?.map((partItem: PartType) => {
        const selectedMold = items?.find(
            (moldItem: SalesOrderLineItemType) =>
                moldItem.revision?.id === partItem.revision?.id,
        )

        const erpMoldId = selectedMold?.erpMoldId || `mold-${selectedMold?.id}`

        return {
            ...partItem,
            erpMoldId,
        }
    })

    return salesItems
}

export const groupByPartRevisionId = (parts: OrderedItemsRecordType[]) => {
    const result = parts.reduce((value, acc) => {
        if (acc['revision']?.id) {
            value[acc['revision'].id] = value[acc['revision'].id] || []
            value[acc['revision'].id].push(acc)
        }

        return value
    }, Object.create({}))

    return result
}

export const getParts = (
    dataSourceOrderedItems: OrderedItemsRecordType[],
    item: SalesOrderLineItemType,
) => {
    const updatedpartsData = (dataSourceOrderedItems || [])
        .filter(part => {
            return !part.associatedErpProductToolId
                ? part.revision?.id === item.revision?.id
                : part.associatedErpProductToolId === item.erpProductToolId
        })
        .sort((partObj1, partObj2) => {
            const firstPartProcess = partObj1?.processName as string
            const secondPartProcess = partObj2?.processName as string

            return firstPartProcess && secondPartProcess
                ? secondPartProcess.length - firstPartProcess.length
                : Number(partObj2.id) - Number(partObj1.id)
        })

    const groupByParts = groupByPartRevisionId(updatedpartsData)

    return groupByParts
}

export const processDisplayName = (process: string) => {
    if (process?.toLowerCase() === PROCESS_DISPLAY_IM_SAMPLE.toLowerCase()) {
        return 'T samples'
    } else if (process?.toLowerCase() === PROCESS_DISPLAY_IM.toLowerCase()) {
        return 'Production parts'
    }
    return process || '-'
}

export const isPartsProductionStatusComplete = (parts: {
    [revisionId: string]: OrderedItemsRecordType[]
}) => {
    return Object.keys(parts).map(partKey => {
        return parts[partKey].some(
            part =>
                part.processName?.toLowerCase() ===
                    PROCESS_DISPLAY_IM.toLowerCase() &&
                part.productionStatus.toLowerCase() ===
                    PRODUCT_COMPLETED_STATUS.toLowerCase(),
        )
    })
}
